import gql from 'graphql-tag'
import client from '@stores/apollo'

export default function remove(id?: string): Promise<any> {
  return client.gql.mutate({
    mutation,
    variables: { input: { id } },
  })
}

const mutation = gql`
  mutation deleteContract($input: DeleteContractInput!) {
    deleteContract(input: $input) {
      contract {
        id
      }
    }
  }
`
